import { useState, useEffect } from "react";

interface NowIndicatorProps {
  readonly offsetPx: number;
}

function useCurrentTime() {
  const [time, setTime] = useState(() => new Date());
  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 10_000);
    return () => clearInterval(interval);
  }, []);
  return time;
}

export function NowIndicator({ offsetPx }: NowIndicatorProps) {
  const time = useCurrentTime();
  const hours = String(time.getHours()).padStart(2, "0");
  const minutes = String(time.getMinutes()).padStart(2, "0");
  const [showTime, setShowTime] = useState(true);

  return (
    <div
      className="absolute left-0 right-0 z-10"
      style={{ top: `${offsetPx}px` }}
    >
      <div className="relative flex items-center">
        {showTime && (
          <span
            className="absolute -left-[48px] -top-[7px] w-[44px] text-right pr-2 text-[10px] text-red-500 font-medium tabular-nums cursor-pointer pointer-events-auto"
            title="Cliquer pour masquer"
            onClick={(e) => { e.stopPropagation(); setShowTime(false); }}
          >
            {hours}:{minutes}
          </span>
        )}
        <span
          className="absolute -left-1 w-2.5 h-2.5 rounded-full bg-red-500 animate-now-pulse cursor-pointer pointer-events-auto"
          title={showTime ? "Masquer l'heure" : "Afficher l'heure"}
          onClick={(e) => { e.stopPropagation(); setShowTime((v) => !v); }}
        />
        <div className="w-full h-0.5 bg-red-500 pointer-events-none" />
      </div>
    </div>
  );
}
